import { OptimizelyExperiments, OptimizelyFeatureFlags } from 'constants/optimizely'

type OptimizelyId = OptimizelyExperiments | OptimizelyFeatureFlags

const analyticsTriggeredFlags = new Map<OptimizelyId, boolean>()

export function triggerAnalytics(id: OptimizelyId, value: boolean = true): void {
  analyticsTriggeredFlags.set(id, value)
}

export function hasAnalyticsTriggered(id: OptimizelyId): boolean {
  return !!analyticsTriggeredFlags.get(id)
}
